import { ContentDescriptionEditable } from '@/components/widget/content-description-editable';
import { Photo } from '@vivport/backend/types';

interface DetailsPhotoProps {
  content: Photo;
  onDescriptionSave: (description: string) => Promise<void>;
  isRegenerating: boolean;
}

export function DetailsPhoto({ content: photo, onDescriptionSave, isRegenerating }: DetailsPhotoProps) {
  return (
    <div data-testid="details-photo" className="flex flex-col gap-4">
      <div className="flex flex-col items-center gap-4">
        <img
          src={`/api/files/photo/${photo.uri}`}
          alt="Photo"
          className="h-[480px] object-cover rounded"
        />
        <ContentDescriptionEditable
          description={photo.description || ''}
          onSave={onDescriptionSave}
          disabled={isRegenerating}
          placeholder={isRegenerating ? "Regeneration currently in progress" : "Click to add description"}
        />
      </div>
    </div>
  );
}
